/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Expires/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Simple/Data/validate.js'
import React from 'react'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'
import TysiaSelectOneWithLabelField from 'DesignSystem/TysiaSelectOneWithLabelField/index'



/** @type {import('Simple/types.js').View} */
export default function Expires({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectDevelopers/CreateToken/Content/Create/Expires",
  onChange,
  isInvalid
  
}) {
let optionsValueData = fromData.useDataValue({ viewPath,
context: 'options',
})
let createTokenExpiresAtValueData = fromData.useDataValue({ viewPath,
context: 'create_token',
path: 'expires_at',
})
let createTokenExpiresAtIsValidData = fromData.useDataIsValid({ viewPath,
context: 'create_token',
path: 'expires_at',
validate: fromValidate.numberPositive,
required: true,
})
let createTokenExpiresAtChangeData = fromData.useDataChange({ viewPath,
context: 'create_token',
path: 'expires_at',
})
  return (<React.Fragment
>
<TysiaSelectOneWithLabelField
  viewPath={`${viewPath}/TysiaSelectOneWithLabelField`}
 data="options"
 from={optionsValueData}
 data="create_token.expires_at"
 value={createTokenExpiresAtValueData}
 onChange={createTokenExpiresAtChangeData}
 required={true}
 validate="/Simple/Data/validate.js numberPositive"
 invalid={!createTokenExpiresAtIsValidData}
 allowEmptyChoice={false}
 placeholder="Expires at"
 label="Expires at"
>
{childProps => (
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
)}
</TysiaSelectOneWithLabelField>
{children}
</React.Fragment>)
}